import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CFactorsGraph = ({ actual = [], categories=[] }) => {
  const [state, setState] = useState({
    chart: {
      type: "column",
      height: "350px",
      toolbar: {
        show: false,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: categories,
      labels: {
        show: true,
        rotation: -20,
        style: {
          color: "#404040",
          fontSize: "10px",
          fontWeight: "600",
        },
      },
      lineWidth: 0,
    },
    tooltip: {
      valueSuffix: "%",
      shared: true,
      crosshair: true,
      style: {
        fontSize: "11px",
        fontWeight: "600",
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
        },
      },
      bar: {
        pointWidth: 10,
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y}%",
        },
      },
    },
  });

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      chart: {
        ...prev.chart,
        height: window.screen.height - window.screen.height / 1.5,
      },
      xAxis: {
        categories: categories,
        labels: {
          show: true,
          rotation: -15,
          style: {
            color: "#404040",
            fontSize: "9px",
            fontWeight: "600",
          },
        },
        lineWidth: 0,
      },
      yAxis: {
        tickAmount: 5,
        title: "",
        labels: {
          format: "{text}%",
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
      },
      series: [
        {
          maxPointWidth: 15,
          showInLegend: false,
          name: "Actual",
          data: actual,
          color: "#0077B6",
        },
      ],
    }));
    // console.log(window.screen.height);
  }, [window.screen.height, actual , categories ]);

  return (
    <div id="chart">
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};

export default CFactorsGraph;
